import React from 'react';

export default () => (
  <svg
    focusable='false'
    xmlns='http://www.w3.org/2000/svg'
    xmlnsXlink='http://www.w3.org/1999/xlink'
    width='24'
    height='24'
    viewBox='0 0 24 24'
  >
    <path d='M9.48 17.126a2 2 0 0 1-3.177.75l-2.928 1.462v1.287h18a.75.75 0 0 1 .743.648l.007.102a.75.75 0 0 1-.648.743l-.102.007H2.625a.75.75 0 0 1-.743-.648l-.007-.102V2.625a.75.75 0 0 1 1.493-.102l.007.102v7.425l3.524-2.113a2.004 2.004 0 0 1-.019-.163l-.005-.149a2 2 0 1 1 3.999.067l2.237.994a1.993 1.993 0 0 1 1.962-.478l3.103-3.88a2 2 0 1 1 .914 1.259l-2.846 3.558a2 2 0 1 1-3.743.912l-2.236-.994c-.36.348-.85.562-1.39.562-.452 0-.869-.15-1.204-.403L3.375 11.8v5.862l2.256-1.128v-.009l-.006-.149a2 2 0 0 1 3.855-.75h2.54a2 2 0 0 1 3.11-.807l2.997-1.665a2 2 0 1 1 .51 1.434L15.86 16.13a2 2 0 0 1-3.84.996zm4.395-1.251a.5.5 0 1 0 0 1 .5.5 0 0 0 0-1zm-6.25 0a.5.5 0 1 0 0 1 .5.5 0 0 0 0-1zm12.5-3.125a.5.5 0 1 0 0 1 .5.5 0 0 0 0-1zM14.5 9.625a.5.5 0 1 0 0 1 .5.5 0 0 0 0-1zm-5.625-2.5a.5.5 0 1 0 0 1 .5.5 0 0 0 0-1zm11.25-3.75a.5.5 0 1 0 0 1 .5.5 0 0 0 0-1z' />
  </svg>
);
